// Create some re-useable definitions because
// many input types are identical in how

import type { FormKitNode } from "@formkit/core"

// we want to style them.
const textClassification = {
  label:
    'block mb-1 font-medium text-sm formkit-invalid:text-red-500 text-gray-700',
  inner: `
    shadow-sm
    border
    border-gray-300
    formkit-invalid:border-red-500
    rounded-lg
    overflow-hidden
    focus-within:border-primary-500
    focus-within:ring-1 
    ring-primary-500
    formkit-invalid:ring-red-500
    outline-none
    w-full
    bg-white
  `,
  input:
    'w-full h-10 px-3 border-none text-sm text-gray-700 placeholder-gray-400',
}
// appearance-none block w-full px-3 py-2.5 border text-sm border-gray-300 text-gray-900 rounded-md placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500
const boxClassification = {
  fieldset: 'max-w-md rounded-md',
  legend: 'font-medium text-sm text-gray-700',
  wrapper: 'flex items-center my-1 cursor-pointer',
  help: 'mt-1 mb-2',
  input:
    'form-check-input appearance-none h-4 w-4 rounded bg-white checked:bg-primary-500 ring-0 focus:outline-none focus:ring-primary-500 transition duration-200 border-gray-300',
  label:
    'block font-medium text-sm formkit-invalid:text-red-500 text-gray-700 ml-3 mt-1',
}
const buttonClassification = {
  wrapper: 'mb-1',
  input:
    'bg-primary-500 hover:bg-primary-700 text-white text-sm font-normal py-3 px-5 rounded',
}

// export our definitions using our above
// templates and declare one-offs and
// overrides as needed.
export default {
  // the global key will apply to all inputs
  global: {
    outer: 'formkit-disabled:opacity-50',
    help: 'mt-1 text-xs text-gray-500',
    messages: 'list-none p-0 mt-1 mb-0',
    message: 'text-red-500 mb-1 text-xs',
  },
  button: buttonClassification,
  color: {
    label:
      'block mb-1 font-medium text-sm formkit-invalid:text-red-500 text-gray-700',
    input:
      'w-16 h-8 appearance-none cursor-pointer border border-gray-300 rounded-md p-1',
  },
  date: textClassification,
  checkbox: boxClassification,
  email: textClassification,
  file: {
    label: 'block mb-1 font-bold text-sm',
    inner: 'max-w-md cursor-pointer',
    input:
      'text-gray-600 text-sm mb-1 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:bg-primary-500 file:text-white hover:file:bg-primary-600',
    noFiles: 'block text-gray-800 text-sm mb-1',
    fileItem: 'block flex text-gray-800 text-sm mb-1',
    removeFiles: 'ml-auto text-primary-500 text-sm',
  },
  month: textClassification,
  number: textClassification,
  password: textClassification,
  radio: {
    ...boxClassification,
    input: boxClassification.input.replace('rounded', 'rounded-full'),
  },
  range: {
    inner: 'max-w-md',
    input:
      'form-range appearance-none w-full h-2 p-0 bg-gray-200 rounded-full focus:outline-none focus:ring-0 focus:shadow-none',
  },
  search: textClassification,
  submit: buttonClassification,
  tel: textClassification,
  text: textClassification,
  textarea: {
    ...textClassification,
    input:
      'block w-full px-3 border-none text-sm text-gray-700 placeholder-gray-400 focus:shadow-outline',
  },
  wysiwyg: {
    ...textClassification,
    inner: `${textClassification.inner} bg-white min-h-[300px]`,
    // inner: `${textClassification.inner} bg-white max-h-[300px] overflow-y-auto`,
  },
  computedText: {
    label: textClassification.label,
    inner: 'h-10',
  },
  select: {
    label: textClassification.label,
  },
  repeater: {
    label: textClassification.label,
  },
  multiselect: {
    ...textClassification,
    inner: textClassification.inner.replace('overflow-hidden', ''),
  },
  adapter: {
    ...textClassification,
    inner: textClassification.inner.replace('overflow-hidden', ''),
  },
  time: textClassification,
  url: textClassification,
  week: textClassification,
  upload: {
    label: textClassification.label,
  },
  channels: {
    outer: 'sticky top-0 z-20',
  },
  imageHotspotTagger: {
    label: textClassification.label,
  },
}

export const requiredSuffixPlugin = (node: FormKitNode) => {
  if (node.props.validation?.includes('required')) {
    node.context.classes.label +=
      " after:content-['*'] after:ml-0.5 after:text-red-400"
    node.context.classes.inner += ' border-indigo-400'
  }
  watch(() => node.context.state.required, () => {
    console.log("Required change triggered", node.context.state.required)
    if (node.context.state.required) {
      node.context.classes.label +=
        " after:content-['*'] after:ml-0.5 after:text-red-400"
      node.context.classes.inner += ' border-indigo-400'
    } else {
      node.context.classes.label = node.context.classes.label.replace("after:content-['*'] after:ml-0.5 after:text-red-400", '')
      node.context.classes.inner = node.context.classes.inner.replace('border-indigo-400', '')
      console.log( node.context.classes.inner)
    }
  })
}
